import { CommonModule } from '@angular/common';
import { Component, effect, input, OnDestroy, OnInit, output, signal } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { skip, Subscription } from 'rxjs';

import { UiAdminModule } from '@eiq/ui';

import { OptionsLibrarySet } from '../../../models/options-library/options-library-form.interface';
import { OptionsLibrarySetCardComponent } from '../options-library-set-card/options-library-set-card.component';

@Component({
  standalone: true,
  selector: 'empathy-options-library-set',
  templateUrl: 'options-library-set.component.html',
  styleUrl: './options-library-set.component.scss',
  imports: [CommonModule, OptionsLibrarySetCardComponent, ReactiveFormsModule, UiAdminModule]
  // TODO: UIAdminModule should be change when Admin UI is refactor to be standalone
})
export class OptionsLibrarySetComponent implements OnInit, OnDestroy {
  optionSets = input<OptionsLibrarySet[]>();

  selected = output<OptionsLibrarySet>();
  delete = output<string>();
  duplicate = output<OptionsLibrarySet>();
  edit = output<OptionsLibrarySet>();

  optionSetsFiltered = signal([]);
  selectedSet$ = signal<string>('');

  filterCtrl = new FormControl('');

  private subscription: Subscription;

  constructor() {
    effect(
      () => {
        if (this.optionSets()) {
          this.optionSetsFiltered.set(this.optionSets());
        }
      },
      { allowSignalWrites: true }
    );
  }

  ngOnInit(): void {
    this.subscription = this.filterCtrl.valueChanges.pipe(skip(1)).subscribe((value) => {
      this.optionSetsFiltered.set(this.optionSets().filter((optSet) => optSet.name.toLocaleLowerCase().includes(value.toLocaleLowerCase())));
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onSelectSet(event: MatCheckboxChange, id: string): void {
    if (event.checked) {
      this.selectedSet$.set(id);
      this.selected.emit(this.optionSets().find((optionSet) => optionSet.id === id));
      return;
    }

    this.selectedSet$.set('');
    this.selected.emit(null);
  }

  onDuplicateOptionSet(id: string): void {
    this.duplicate.emit(this.optionSets().find((optionSet) => optionSet.id === id));
  }

  onEditOptionSet(id: string): void {
    this.edit.emit(this.optionSets().find((optionSet) => optionSet.id === id));
  }

  onDeleteOptionSet(id: string): void {
    this.delete.emit(id);
  }
}
